import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";
import PopupComponent from "./popup-register-page-component";
import * as data from "src/core/statics/Termsـconditionsـprivacyـpolicy/static_data";

function PolicyAndPrivacyComponent() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [isOpenPopupTermsAndConditions, setIsOpenPopupTermsAndConditions] =
    useState<boolean>(false);
  const [isOpenPopupPrivacyAndPolicy, setIsOpenPopupPrivacyAndPolicy] =
    useState<boolean>(false);
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutSidePopup = ({ target }: MouseEvent) => {
      if (!popupRef?.current?.contains(target as Node)) {
        setIsOpenPopupTermsAndConditions(false);
        setIsOpenPopupPrivacyAndPolicy(false);
      }
    };
    document.body.addEventListener("click", handleClickOutSidePopup, true);

    return () => {
      document.body.removeEventListener("click", handleClickOutSidePopup);
    };
  }, []);

  return (
    <>
      <div className="w-[533px] h-14 mobile:w-[341px] flex-col justify-start items-center gap-2 inline-flex">
        <div className="text-center mobile:text-center">
          <span className="text-zinc-400 text-lg font-arMedium leading-7 mobile:text-sm">
            {t("registerForm.component.agree")}
          </span>
          <span
            onClick={() => setIsOpenPopupTermsAndConditions(true)}
            className="text-slate-700 text-lg font-arMedium leading-7 cursor-pointer mobile:text-sm"
          >
            {t("registerForm.component.termsAndCondition")}
          </span>
          <span className="text-zinc-400 text-lg font-arMedium leading-7">
            {t("registerForm.component.and")}
          </span>
          <span
            onClick={() => setIsOpenPopupPrivacyAndPolicy(true)}
            className="text-slate-700 text-lg font-arMedium leading-7 cursor-pointer mobile:text-sm"
          >
            {t("registerForm.component.privacyAndpolicy")}
          </span>
        </div>
        <div className="w-[250px] h-[21px] text-center">
          <span className="text-zinc-400 text-base font-arMedium leading-normal mobile:text-sm">
            {t("app.shared.haveaccount")}
          </span>
          <span
            onClick={() => navigate(appRoutesObj.getSignInPagePath())}
            className="text-mint-500 text-base font-arMedium leading-normal cursor-pointer mobile:text-sm"
          >
            {t("app.shared.signin")}
          </span>
        </div>
      </div>
      <div ref={popupRef}>
        <PopupComponent
          isOpen={isOpenPopupTermsAndConditions}
          title={
            i18n.language === "ar"
              ? data.termsAndConditions.title
              : data.termsAndConditions.titleEn
          }
          description={
            i18n.language === "ar"
              ? data.termsAndConditions.description
              : data.termsAndConditions.descriptionEn
          }
        />
        <PopupComponent
          isOpen={isOpenPopupPrivacyAndPolicy}
          title={
            i18n.language === "ar"
              ? data.privacyAndPolicy.title
              : data.privacyAndPolicy.titleEn
          }
          description={
            i18n.language === "ar"
              ? data.privacyAndPolicy.description
              : data.privacyAndPolicy.descriptionEn
          }
        />
      </div>
    </>
  );
}

export default PolicyAndPrivacyComponent;
